import React from "react";
import styles from "../styles/LegalPage.module.css";

const CookiePolicy = () => (
  <div className={styles.legalWrapper}>
    <h1>Cookie Policy</h1>
    <p>Vionex Labs uses cookies to enhance your experience. By using our site, you consent to our use of cookies.</p>
    <h2>What Are Cookies?</h2>
    <ul>
      <li>Small files stored on your device to remember preferences and usage</li>
    </ul>
    <h2>How We Use Cookies</h2>
    <ul>
      <li>Analytics and site improvement</li>
      <li>Remembering your preferences</li>
    </ul>
    <h2>Managing Cookies</h2>
    <ul>
      <li>You can disable cookies in your browser settings</li>
    </ul>
    <p>Contact us at support@vionexlabs.com for cookie policy questions.</p>
  </div>
);

export default CookiePolicy;
